import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, timeout } from 'rxjs'; // 👉 Imported timeout

export interface RequestOptions {
  headers?: HttpHeaders | Record<string, string | string[]>;
  params?: HttpParams | Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>>;
  reportProgress?: boolean;
  withCredentials?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private http = inject(HttpClient);
  private readonly TIMEOUT_MS = 10000; // 👉 10 Second safe timeout

  get<T>(url: string, options?: RequestOptions): Observable<T> {
    return this.http.get<T>(url, options).pipe(timeout(this.TIMEOUT_MS));
  }

  post<T>(url: string, body: any | null, options?: RequestOptions): Observable<T> {
    return this.http.post<T>(url, body, options).pipe(timeout(this.TIMEOUT_MS));
  }

  put<T>(url: string, body: any | null, options?: RequestOptions): Observable<T> {
    return this.http.put<T>(url, body, options).pipe(timeout(this.TIMEOUT_MS));
  }

  delete<T>(url: string, options?: RequestOptions): Observable<T> {
    return this.http.delete<T>(url, options).pipe(timeout(this.TIMEOUT_MS));
  }
}